import jsPDF from "jspdf";
import { LossRatioResponse } from "../interfaces/reclamaciones.interface";
import { logoBase64 } from "../../../public/assets/logoBase64";

interface params {
  data: Record<string, {
    records: LossRatioResponse[],
    totalPeriodPremium: number,
    totalIncurred: number,
    totallossRatio: number
  }>;
  usuario: string | null;
  fechas: {
    desde: Date;
    hasta: Date
  };
}
export const exportarDetallesPDF = ({ data, usuario, fechas }: params) => {
  const doc = new jsPDF({ orientation: "landscape" }) as any; // Orientación landscape

  let currentY = 15; // Posición inicial del primer "Deudor" de la pagina
  const pageHeight = doc.internal.pageSize.height;

  let fechaHastaFormat = new Date(new Date(fechas.hasta).setDate(new Date(fechas.hasta).getDate() + 1))
    .toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });


  // Header de la página
  const pageHeader = (doc: any) => {
    doc.addImage(logoBase64, "PNG", 10, 10, 40, 13);
    doc.setFontSize(16);
    doc.text(`Listado de Sinestralidad - Portal Intermediario`, 55, 15);
    doc.setFontSize(12);
    doc.text(`${usuario}`, 55, 20);
    doc.text(`Fecha Corte: ${fechaHastaFormat}`,  14, 28);
  }
  doc.autoTable({
    didDrawPage: () => pageHeader(doc),
  });


  // Creación de tablas de deudores
  Object.keys(data).forEach(subramo => {
    if (currentY + 55 > pageHeight) { // Cambio de página por límite de espacio excedido
      doc.addPage();
      doc.autoTable({
        didDrawPage: pageHeader(doc),
      });
      currentY = 15; // Reseteo de la posición inicial del primer "Deudor" de la pagina
    }

    doc.setFontSize(12);
    doc.text(`${data[subramo].records[0].slob}     ${data[subramo].records[0].lobDescription}`, 25, currentY + 20);

    // Tabla de polizas "agingProducers"
    const body = data[subramo].records.map((record) => [
      record.policyNumber,
      record.clientName,
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(record.periodPremium),
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(record.totalIncurred),
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(record.lossRatio),
    ]);

    body.unshift(['Póliza', 'Cliente', 'Prima Período', 'Total Incurido', 'Sinestralidad'])

    body.push([
      '',
      `Total ${data[subramo].records[0].lobDescription}`,
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(data[subramo].totalPeriodPremium),
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(data[subramo].totalIncurred),
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(data[subramo].totallossRatio)
    ])
    doc.autoTable({
      startY: currentY + 23,
      body: body,
      margin: { left: 10 },
      headStyles: {
        fillColor: [0, 85, 140], // Background color in RGB
        textColor: [255, 255, 255], // Text color (white)
        fontSize: 10,
        halign: 'left'
      },
      columnStyles: {
        0: { halign: 'left' },
        1: { halign: 'left' },
        2: { halign: 'right' },
        3: { halign: 'right' },
        4: { halign: 'right' },
      },
      didDrawCell: (data: any) => {
        const { cell } = data;
        const x = cell.x;
        const y = cell.y;
        const w = cell.width;
        const h = cell.height;
      },
      didParseCell: function (data: any) {
        // Aplica estilos solo a la primera fila del body
        if (data.row.index === 0 && data.section === 'body') {
          data.cell.styles.valign = 'bottom'; // Grosor del borde
          data.cell.styles.lineWidth = 0; // Grosor del borde
          data.cell.styles.lineWidth = { bottom: 1 }; // Grosor del borde
          data.cell.styles.lineColor = [255, 165, 0]; // Borde naranja (RGB)
          data.cell.styles.fillColor = [255, 255, 255]; // Color de fondo azul
          data.cell.styles.textColor = [0, 0, 0]; // Texto blanco
          data.cell.styles.fontStyle = 'bold'; // Texto en negrita
          data.cell.styles.fontSize = 10; // Texto en negrita
          // row.cell.styles.halign = 'left'; // Alineación centrada
        }
        if (data.row.index === data.table.body.length - 1 && data.section === 'body') {
          data.cell.styles.lineWidth = 0; // Grosor del borde
          data.cell.styles.lineWidth = { bottom: 1 }; // Grosor del borde
          data.cell.styles.lineColor = [0, 0, 0]; // Borde negro (RGB)
          data.cell.styles.fillColor = [255, 255, 255]; // Color de fondo azul
          data.cell.styles.textColor = [0, 0, 0]; // Texto blanco
          data.cell.styles.fontStyle = 'bold'; // Texto en negrita
        }
      },
    });
    // Actualiza la posición en Y para el siguiente "subramo" de la página
    currentY = doc.lastAutoTable.finalY - 10;
  });

  // Save the PDF
  doc.save("Sinestralidad Detalle Poliza.pdf");
};


export const exportarTotalesPDF = ({ data, usuario, fechas }: params) => {
  const doc = new jsPDF({ orientation: "landscape" }) as any; // Orientación landscape

  let fechaHastaFormat = new Date(new Date(fechas.hasta).setDate(new Date(fechas.hasta).getDate() + 1))
    .toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });


  let currentY = 15; // Posición inicial del primer "Deudor" de la pagina

  // Header de la página
  const pageHeader = (doc: any) => {
    doc.addImage(logoBase64, "PNG", 10, 10, 40, 13);
    doc.setFontSize(16);
    doc.text(`Resumen Sinestralidad por Sub-Ramo - Portal Intermediario`, 55, 15);

    doc.setFontSize(12);
    doc.text(`${usuario}`, 55, 20);
    doc.text(`Fecha corte: ${fechaHastaFormat}`,  14, 28);
  }
  doc.autoTable({
    didDrawPage: () => pageHeader(doc),
  });
  let body = [];
  let totalPeriodPremium: number = 0;
  let totalIncurred: number = 0;
  let totallossRatio: number = 0;

  // Creación de tablas de deudores
  Object.keys(data).forEach(subramo => {
    // Tabla de polizas "agingProducers"
    const subramoData = [
      data[subramo].records[0].slob,
      data[subramo].records[0].lobDescription,
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(data[subramo].totalPeriodPremium),
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(data[subramo].totalIncurred),
      new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(data[subramo].totallossRatio),
    ];
    totalPeriodPremium = totalPeriodPremium + data[subramo].totalPeriodPremium;
    totalIncurred = totalIncurred + data[subramo].totalIncurred;
    totallossRatio = totallossRatio + data[subramo].totallossRatio;

    body.push(subramoData);
  });

  body.unshift(['Ramo', '', 'Prima Período', 'Total Incurido', 'Sinestralidad']);
  body.push([
    '',
    `Total`,
    new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalPeriodPremium),
    new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalIncurred),
    new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totallossRatio)
  ])

  doc.autoTable({
    startY: currentY + 23,
    body: body,
    margin: { left: 10 },
    headStyles: {
      fillColor: [0, 85, 140], // Background color in RGB
      textColor: [255, 255, 255], // Text color (white)
      fontSize: 10,
    },
    columnStyles: {
      0: { halign: 'left' },
      1: { halign: 'left' },
      2: { halign: 'right' },
      3: { halign: 'right' },
      4: { halign: 'right' },
    },
    didDrawCell: (data: any) => {
      const { cell } = data;
      const x = cell.x;
      const y = cell.y;
      const w = cell.width;
      const h = cell.height;
    },
    didParseCell: function (data: any) {
      // Aplica estilos solo a la primera fila del body
      if (data.row.index === 0 && data.section === 'body') {
        data.cell.styles.valign = 'bottom'; // Grosor del borde
        data.cell.styles.lineWidth = 0; // Grosor del borde
        data.cell.styles.lineWidth = { bottom: 1 }; // Grosor del borde
        data.cell.styles.lineColor = [255, 165, 0]; // Borde naranja (RGB)
        data.cell.styles.fillColor = [255, 255, 255]; // Color de fondo azul
        data.cell.styles.textColor = [0, 0, 0]; // Texto blanco
        data.cell.styles.fontStyle = 'bold'; // Texto en negrita
        data.cell.styles.fontSize = 10; // Texto en negrita
        // row.cell.styles.halign = 'left'; // Alineación centrada
      }
      if (data.row.index === data.table.body.length - 1 && data.section === 'body') {
        data.cell.styles.lineWidth = 0; // Grosor del borde
        data.cell.styles.lineWidth = { bottom: 1 }; // Grosor del borde
        data.cell.styles.lineColor = [0, 0, 0]; // Borde negro (RGB)
        data.cell.styles.fillColor = [255, 255, 255]; // Color de fondo azul
        data.cell.styles.textColor = [0, 0, 0]; // Texto blanco
        data.cell.styles.fontStyle = 'bold'; // Texto en negrita
      }
    },
  });

  // Save the PDF
  doc.save("Sinestralidad Totales.pdf");
};




// const object = {
//   "records": [
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120025908",
//       "periodPremium": 129.6,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Mova, SRL ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120035764",
//       "periodPremium": 384.8,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120036034",
//       "periodPremium": 402.29,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120036227",
//       "periodPremium": 1486.65,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120036229",
//       "periodPremium": 1346.78,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120036231",
//       "periodPremium": 1451.73,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120036244",
//       "periodPremium": 822.03,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120036444",
//       "periodPremium": 717.09,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120036464",
//       "periodPremium": 612.15,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037252",
//       "periodPremium": 174.9,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037377",
//       "periodPremium": 279.84,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037420",
//       "periodPremium": 227.38,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037431",
//       "periodPremium": 1026.23,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037433",
//       "periodPremium": 472.23,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037465",
//       "periodPremium": 244.86,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037547",
//       "periodPremium": 1089.79,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037548",
//       "periodPremium": 1376.65,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037549",
//       "periodPremium": 1371.02,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037572",
//       "periodPremium": -0.0001,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037608",
//       "periodPremium": 262.36,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120037636",
//       "periodPremium": 104.94,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "Instituto Tecnologico de Sto. Dgo. (INTEC)  ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     },
//     {
//       "lob": 11,
//       "slob": 112,
//       "policyNumber": "221120038041",
//       "periodPremium": 5774.05,
//       "totalIncurred": 0,
//       "lossRatio": 0,
//       "clientName": "M.P.G., S.R.L. ",
//       "lobDescription": "Accidentes Personales Colectivos"
//     }
//   ],
//   "totalPeriodPremium": 19757.3699,
//   "totalIncurred": 0,
//   "totallossRatio": 0
// }
